import type { SortField, CalculatedColumn, RowOrGroup } from "../types";

import { compareValues } from "./comparator";

interface SortColumn<R extends object> extends SortField, Pick<CalculatedColumn<R>, "groupValueGetter" | "valueGetter" | "type"> {}

export function createSortComparator<R extends object>(sortColumns: SortColumn<R>[] = []) {
  return (a: RowOrGroup<R>, b: RowOrGroup<R>) =>
    sortColumns.reduce((acc, sortCol) => {
      if (acc !== 0) {
        return acc;
      }

      const valueA = Array.isArray(a) ? sortCol.groupValueGetter(a) : sortCol.valueGetter(a);
      const valueB = Array.isArray(b) ? sortCol.groupValueGetter(b) : sortCol.valueGetter(b);

      const result = compareValues(valueA, valueB, sortCol.type);

      return sortCol.direction === "ASC" ? result : -result;
    }, 0);
}
